<template>
    <div>
        <section class="section has-background-primary has-text-centered">
            <br><br><br>
            <div class="container">
                <h1 class="title has-text-white">Frequently Asked Questions For Sellers</h1>
                <p class="subtitle is-6 has-text-white">We have compiled a list of the most common questions asked by our sellers</p>
            </div>
        </section>

        <section class="section">
            <div class="container faq-box">
                <CollapseDiv labelSize="big" labelText="General" type="radio" name="Overall">
                    <hr>
                    <CollapseDiv labelText="Why do I need an estate agent to sell my home?" type="radio" name="General">
                        <p>Selling a home is a complicated process. Unless you are an experienced real estate agent familar with pricing of your home, local market trends, negotiations and legal documents, you will need assistance to achieve the best possible offer in the shortest amount of time</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="Who is NestEgg?" type="radio" name="General">
                        <p>NestEgg is unique in South Africa.</p>
                        <p>We are the only real estate company focused on YOU, The Seller, which means we will always look after your best interests and source buyers through a panel of the top approved partner agents in your area.</p>
                        <p>Our business model is based on real estate companies in the USA and the United kingdom where sellers and buyers are not represented by the SAME estate agent.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="Why should I sell with NestEgg?" type="radio" name="General">
                        <p>Our approach of only representing YOU as the seller ensures that everything we do is to protect your interests and sell your home at the best price.</p>
                        <p>Working with the best partner agents in your area enables us to source more buyers and improve your likelhood of selling faster at the highest price.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="How does selling with NestEgg work?" type="radio" name="General">
                        <p>It's simple!</p>
                        <ul class="ul-bullets">
                           
                            <li>We visit your home to give our detailed valuation supported by:
                                <ul>
                                <li>Our expert suburb knowledge</li>
                                <li>Lightstone valuation tools</li>
                                </ul>
                            </li>
                            <li>You agree on your Listing Price</li>

                            <li>You accept the valuation</li>
                            <li>We list your home on our website and on leading national property listing sites such as Property24 and Private Property through our Partner approved agents</li>
                            <li>We help you negotiate your sale and pay for legal advice</li>
                        </ul>
                        <br>
                    </CollapseDiv>
                    <CollapseDiv labelText="How do I start the process with NestEgg?" type="radio" name="General">
                        <p>1. Complete our contact form and we will call you</p>
                        <p>2. We use our Lightstone tools to give you an instant online valuation</p>
                        <p>3. If you are happy, you sign up NestEgg as your seller's agent</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="Which areas does NestEgg operate in?" type="radio" name="General">
                        <p> NestEgg currently operates in the greater Cape Town area.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="What types of property will NestEgg list?" type="radio" name="General">
                        <p>NestEgg’s focus is on residential properties:</p>
                        <ul class="ul-bullets">
                            <li>Sectional Title Apartments</li>
                            <li>Residential Free-standing Homes</li>
                            <li>Properties in Gated Estates and Security Complexes</li>
                            <li>Properties valued between R1,000,000 - R5,000,000</li>
                        </ul>
                        <br>
                    </CollapseDiv>
                    <CollapseDiv labelText="Are there any types of homes that NestEgg won't list?" type="radio" name="General">
                        <p>NestEgg will be unable to assist with:</p>
                        <ul class="ul-bullets">
                            <li>Commercial properties</li>
                            <li>Guest Houses</li>
                            <li>Thatched properties</li>
                            <li>Vacant land</li>
                        </ul>
                        <br>
                    </CollapseDiv>
                    <CollapseDiv labelText="Can I still sell with NestEgg if I already have a mandate with another estate agent?" type="radio" name="General">
                        <p>No, unfortunately you’ll have to cancel the mandate or wait for it to expire before we can help.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="Is there someone I can talk to about my requirements?" type="radio" name="General">
                        <p>Our expert agents can assist right away. Simply <router-link class="plain-link" to="/contact-us">click here</router-link> and one of our agents will call you back.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="How long does the selling process take with NestEgg?" type="radio" name="General">
                        <p>Property sales are subject to various market factors and usually take anywhere between 2 and 12 months to sell. Pricing right and using our NestEgg approach we are committed to helping you sell quicker at a better price.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="What if my home needs repairs?" type="radio" name="General">
                        <p>Our on-site Valuation will establish the condition of your home. To sell quicker if your home is in poor repair you may need to:</p>
                        <ul class="ul-bullets">
                            <li>Do essentail repairs or alterations</li>
                            <li>Adjust your price to compensate for future repairs</li>
                        </ul>
                        <br>
                    </CollapseDiv>
                </CollapseDiv>
            </div>
            <br>

            <div class="container faq-box">
                <CollapseDiv labelSize="big" labelText="Pricing" type="radio" name="Overall">
                    <hr>
                    <CollapseDiv labelText="How does NestEgg value my home?" type="radio" name="Pricing">
                        <p>Our experienced agent will assess your home's value based on:</p>
                        <ul class="ul-bullets">
                            <li>Lightstone digital valuation tools</li>
                            <li>Location</li>
                            <li>Comparable Sales in your area</li>
                            <li>Property Attributes (bedrooms, bathrooms, etc.)</li>
                            <li>Property Size</li>
                            <li>Condition (Is there maintenance/repairs required?)</li>
                        </ul>
                        <br>
                    </CollapseDiv>
                    <CollapseDiv labelText="How much does it cost to sell with NestEgg?" type="radio" name="Pricing">
                        
                        <p>Agent Fees</p>
                        <ul class="ul-bullets">
                            <li>Total agent fees (commission) are recommended at 5% (excluding VAT) on the successful sale of your home</li>
                            <li>NestEgg and our Approved Agent will share in the recommended commission</li>
                        </ul>
                        <ul class="ul-bullets">
                            <li>You sell for R2,000,000</li>
                            <li>If Total Commission negotiated with seller is 5%* - R100 000
                                <ul class="ul-bullets">
                                    <li>The buyers agent gets 3% - R60 000</li>
                                    <li>NestEgg gets 2% - R40 000</li>
                                </ul>
                                <span>*All figures above exclude VAT</span>
                            </li>
                            <li>**NOTE** we are here to get you the best sale price and ensure you only pay a fair agent commission</li>
                        </ul>
                        <br>
                    </CollapseDiv>
                    <CollapseDiv labelText="Will I be liable for double commission if another agent brings a buyer?" type="radio" name="Pricing">
                        <p>No - our model is designed to work with agents to ensure you get access to the best buyers</p>
                    </CollapseDiv>
                </CollapseDiv>
            </div>
            <br>

            <div class="container faq-box">
                <CollapseDiv labelSize="big" labelText="Listings" type="radio" name="Overall">
                    <hr>
                    <CollapseDiv labelText="How will my home be marketed?" type="radio" name="Listings">
                        <p>We will market your home:</p>
                        <ul class="ul-bullets">
                            <li>On the NestEgg Website</li>
                            <li>On leading national property listing sites, such as Property24 and Private Property - Through our Partner approved agents</li>
                        </ul>
                        <br>
                        <p>We will ensure that the online listing photographs and content used by our Partner Agents, in marketing of your home are of the highest standard and accurate. In addition, we will present listing content to you to ensure that it is to your satisfaction.</p>
                        <p>The Partner Agents we select are  ONLY the most reputable and best performing agents in your area</p>
                        <br>
                    </CollapseDiv>
                    <CollapseDiv labelText="Do I have to pay for my listing?" type="radio" name="Listings">
                        <p>No, your listing is free.</p>
                        <p>You will only pay NestEgg fees if we achieve a successful sale for you</p>
                    </CollapseDiv>
                </CollapseDiv>
            </div>
            <br>

            <div class="container faq-box">
                <CollapseDiv labelSize="big" labelText="Viewings" type="radio" name="Overall">
                    <hr>
                    <CollapseDiv labelText="Who will coordinate the viewings?" type="radio" name="Viewings">
                        <p>Viewings will be coordinated through our approved Partner agents, however NestEgg will continue monitor viewing and buyer feedback to keep you updated</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="Can I do my own viewings?" type="radio" name="Viewings">
                        <p>We strongly recommend against own viewings - they present a serious security risk to you and it is not ideal for sellers and buyers to negotiate directly.</p>
                    </CollapseDiv>
                    <CollapseDiv labelText="Does NestEgg do showdays?" type="radio" name="Viewings">
                        <p>We do not do Show Days as we believe they are an unnecessary security risk and do not add much value</p>
                    </CollapseDiv>
                </CollapseDiv>
            </div>
        </section>
    </div>
</template>

<script>
    import CollapseDiv from '../components/CollapseDiv'
    export default {
        components: {
          CollapseDiv
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/colours.scss';

    hr {
        background-color: $primary;
    }

    .faq-box {
        background-color: $grey-superlight;
        border-radius: 10px;
        padding: 0.5rem 2rem;
    }

    .collapsible-content p {
        margin-bottom: 1em;
    }
</style>